import { createActionConst } from '../../../../utils/action.utils';

const REPORT_NAMESPACE = 'MEETING_REPORTS';

export const FETCH_MEETING_REPORTS = createActionConst(REPORT_NAMESPACE, 'FETCH_MEETING_REPORTS');

export const FETCH_USER_REPORTS = createActionConst(REPORT_NAMESPACE, 'FETCH_USER_REPORTS');

export const STORE_USER_REPORTS = createActionConst(REPORT_NAMESPACE, 'STORE_USER_REPORTS');
export const CLEAR_USER_REPORTS = createActionConst(REPORT_NAMESPACE, 'CLEAR_USER_REPORTS');

export const STORE_MEETING_REPORTS = createActionConst(REPORT_NAMESPACE, 'STORE_MEETING_REPORTS');
export const CLEAR_MEETING_REPORTS = createActionConst(REPORT_NAMESPACE, 'CLEAR_MEETING_REPORTS');
